/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import {
  Row,
  Table,
  Col,
  Typography,
  Form,
  notification,
  Select,
  Tooltip,
  Skeleton,
  Input,
  Radio,
} from 'antd';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button as CrceButton, Checkbox as CrceCheckbox } from '@crc-evans/ui-components';
import { Wrench, Eye, Pencil, Trash2, X, Plus } from 'lucide-react';
import { getProjectTableLoadingConfig } from './ProjectTableLoader';
import { ProjectTabTableEmpty } from './project/ProjectTabTableEmpty';
import './EquipmentPage.css';
import './ShippingManagement/ShipmentDashBoardPage.css';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import EquipmentLogs from './EquipmentLogs';
import { connect } from 'react-redux';
import {
  addEquipDetails,
  deleteEquipDetails,
  fetchEquipCategory,
  fetchEquipDetails,
  fetchEquipMaintenanceIntervalDetails,
  getChecksDetails,
  getChecksLogDetails,
  updateEquipDetails,
} from '../redux/pihEquipmentDetails/action';
import moment from 'moment';
import { fetchMaintenanceTypes } from '../redux/maintenance/action';
import { fetchMaterialList } from '../redux/materialDescription/action';
import { fetchAdminEquipTypes } from '../redux/admin/equipmentTypes/action';
import {
  fetchAdminMaintenanceTypes,
  fetchAdminMaintenanceTypesByID,
} from '../redux/admin/maintenance/action';
import {
  fetchAdminEquipSno,
  fetchAdminDocumentSubTypeSno,
} from '../redux/admin/equipmentSno/action';
import { getPopupContainerBody } from './ShippingManagement/shipmentFieldOptions';
import '../pages/technical/HeatProfilePage.css';
import './DPR/DPRSettingsPipelinesTab.css';
import { useHeatStyleColumnFacets, HEAT_STYLE_FACET_PAGE_CAP } from './technical/heatStyleColumnFacets';
const { Text } = Typography;
const { Option } = Select;

const EQUIPMENT_FACET_KEYS = [
  'pihEquipmentTypeCategory',
  'pihEquipmentType',
  'serialNumber',
  'description',
  '__usageStatusLabel',
];

const EQUIPMENT_COLUMN_FILTERS_EMPTY = EQUIPMENT_FACET_KEYS.reduce((acc, k) => {
  acc[k] = '';
  return acc;
}, {});

function enrichEquipmentRowForFacets(row) {
  if (!row || typeof row !== 'object') return row;
  const title =
    row.usageStatus === 1 ? 'In use' : row.usageStatus === 2 ? 'In backup' : '—';
  return { ...row, __usageStatusLabel: title };
}

const Equipment = (props) => {
  const {
    selectedProject,
    equipmentList,
    onAddEquipData,
    isEquipDetailsLoading,
    onFetchEquipDetails,
    isGetEquipDetailsLoading,
    isEquipUpdateLoading,
    equipDetails,
    equipDataCount,
    onUpdateEquipData,
    isEquipDeleteLoading,
    onDeleteEquipDetails,
    isChecksLoading,
    checksDetails,
    ongetChecksData,
    onGetMaintenanceTypes,
    maintenanceTypes,
    onGetMaterialList,
    materialList,
  } = props;

  const {
    onGetAdminEquipmentTypes,
    adminEquipTypes,
    onGetAdminMaintenanceTypes,
    onGetAdminMaintenanceTypesById,
    adminMaintenanceTypes,
    onGetEquipSno,
    adminEquipSnoData,
    adminEquipSnoLoading,
    adminMaintenanceTypesById,
    isAdminMaintenanceLoading,
    onGetCheckIntervals,
    // intervalsList,
    // isIntervalsLoading,
    onGetEquipMaintenanceInterval,
    equipMaintenanceIntervalData,
    equipMaintenanceIntervalLoading,
    checksDetailsLog,
    onGetChecksLogs,
    onGetCategory,
    onFetchAdminDocumentSubTypeSno,
    isCategoryLoading,
    categoryData,
    adminEquipTypesLoading,
    adminDocumentSubTypeSnoData,
    adminDocumentSubCategoryLoad,
    projectTeamMembersAccessList,
    userAccessList,
  } = props;

  const [projectIdValue, setProjectIdValue] = useState(false);
  const [equipmentFormData] = Form.useForm();

  const [isEquipmentModalVisible, setIsEquipmentModalVisible] = useState(false);
  const [pihEquipment, setPihEquipment] = useState('');
  const [planned, setPlanned] = useState('');
  const [backup, setBackup] = useState('');
  const [editValue, setEditValue] = useState(false);
  const [newEquipment, setNewEquipment] = useState('');
  const [isEquipmentReportModalVisible, setIsEquipmentReportModalVisible] = useState(false);
  const [isTableModelVisible, setIsTableModelVisible] = useState(false);
  const [serialNo, setSerialNo] = useState('');
  const [serialNoList, setSerialNoList] = useState([]);

  const [dailyActive, setDailyActive] = useState('active');
  const [weeklyActive, setWeeklyActive] = useState('');
  const [monthlyActive, setMonthlyActive] = useState('');

  const [activeKey, setActiveKey] = useState('daily');

  const [equipTitle, setEquipTitle] = useState('');
  const [equipId, setEquipId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');

  const [equipmentLogs, setEquipmentLogs] = useState('');
  const [calenderView, setCalenderView] = useState('');
  const [checksData, setChecksData] = useState([]);
  const [checksDataLog, setChecksDataLog] = useState([]);
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const [selectedDateInput, setSelectedDateInput] = useState(null);

  const [selectedMaintenanceType, setSelectedMaintenanceType] = useState([]);

  //setting admin equipment details
  const [adminEquipmentTypes, setAdminEquipmentTypes] = useState([]);
  const [adminMaintenanceTypesList, setAdminMaintenanceTypesList] = useState([]);

  const [adminEquipTypeId, setAdminEquipTypeId] = useState();
  const [adminEquipSnoId, setAdminEquipSnoId] = useState();
  const [clickedTableData, setClickedTableData] = useState(false);

  const [pihCategory, setPihCategory] = useState('');
  const [historyCurrentPage, setHistoryCurrentPage] = useState(1);

  const [heatColumnFilters, setHeatColumnFilters] = useState(() => ({ ...EQUIPMENT_COLUMN_FILTERS_EMPTY }));
  const [equipmentSort, setEquipmentSort] = useState({
    key: 'pihEquipmentTypeCategory',
    desc: false,
  });
  const [assignSpares, setAssignSpares] = useState(false);

  //Equipment write access control for normal user
  const isButtonDisabled = () => {
    if (userAccessList.includes('admin') || userAccessList.includes('super-admin')) return false;
    else if (projectTeamMembersAccessList[0]?.isGuestUser) {
      return true;
    } else if (
      projectTeamMembersAccessList[0]?.isNormalUser &&
      !projectTeamMembersAccessList[0]?.tabPermissions?.Equipment?.write
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isWriteAccess = isButtonDisabled();

  const [adminCompare, setAdminCompare] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(true);
  const [selectedEquipment, setSelectedEquipment] = useState(true);
  const [typesLoading, setTypesLoading] = useState(false);
  const [configuredMaintenanceTypes, setConfiguredMaintenanceTypes] = useState([]);

  const [equipmentLogsForm] = Form.useForm();
  const equipLogsDateHeaderSlotRef = useRef(null);

  const [intervalListData, setIntervalListData] = useState([]);
  const [pihMaintenanceType, setPihMaintenanceType] = useState('');
  const [intervalIdCheck, setIntervalIdCheck] = useState('');
  const [maintenanceIdCheck, setMaintenanceIdCheck] = useState('');
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const [categoryDataList, setCategoryDataList] = useState([]);

  /** Fetching API to get  Equipment details */
  useEffect(() => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      setCurrent(1);
      setPageSize(10);
      setHeatColumnFilters({ ...EQUIPMENT_COLUMN_FILTERS_EMPTY });
      setEquipmentSort({ key: 'pihEquipmentTypeCategory', desc: false });
      var obj = {
        projectId: projId,
        pageSize: HEAT_STYLE_FACET_PAGE_CAP,
        pageNumber: 1,
      };
      onFetchEquipDetails(obj);
      // onGetMaintenanceTypes();
      // onGetMaterialList();
      setStartDateInput(moment(selectedProject.startDate));
      setEndDateInput(moment(selectedProject.endDate));

      //Get Admin Types to add Project Equipments
      // onGetAdminEquipmentTypes();
      onGetCategory();
      // onGetAdminMaintenanceTypes();
    }
    setProjectIdValue(projId);
    setHeatColumnFilters({ ...EQUIPMENT_COLUMN_FILTERS_EMPTY });
  }, [selectedProject]);

  /** Getting admin Equipment details on load */
  // useEffect(() => {
  //   setAdminEquipmentTypes(adminEquipTypes);

  //   //with no category on edit click function - New Enhancement for Category
  //   if (adminEquipTypes && adminEquipTypes.length > 0 && editValue) {
  //     const equipmentTypeId = adminEquipTypes.find(u => u.name === equipId.name);
  //     onGetAdminMaintenanceTypesById({ id: equipmentTypeId.id });
  //     onGetEquipMaintenanceInterval(equipId.id);

  //     setTimeout(() => {
  //       setLoadUpdate(false);
  //     }, 500);
  //   }
  // }, [adminEquipTypes]);

  /**Setting loading functionality for maintenance types  */
  useEffect(() => {
    if (isAdminMaintenanceLoading) {
      setTypesLoading(true);
      // setLoadUpdate(true);
    } else {
      setTypesLoading(false);
      setLoadUpdate(false);
    }
  }, [isAdminMaintenanceLoading]);

  /**Setting loading functionality for maintenance types (specific pih equipment) */
  useEffect(() => {
    if (equipMaintenanceIntervalLoading) {
      setTypesLoading(true);
    } else {
      setTypesLoading(false);
    }
  }, [equipMaintenanceIntervalLoading]);

  /**Setting skeleton loading functionality on click of update to set all the values */
  // useEffect(() => {
  //   if (equipMaintenanceIntervalLoading && isAdminMaintenanceLoading) {
  //     setLoadUpdate(true);
  //     setTypesLoading(true);
  //   } else {
  //     setLoadUpdate(false);
  //     setTypesLoading(false);
  //   }
  // }, [equipMaintenanceIntervalLoading], [isAdminMaintenanceLoading]);

  /** Updating values while clicking update  */
  const showEditModal = async (record) => {
    let editData = null;
    if (record != null) {
      editData = {
        pihEquipment: record.pihEquipmentType,
        serialNo: record.serialNumber,
        pihCategory: record.pihEquipmentTypeCategory,
      };
      setEquipId(record);
      setLoadUpdate(true);

      setPihCategory(record.pihEquipmentTypeCategory);
      setPihEquipment(record.pihEquipmentType);
      setSerialNo(record.serialNumber);
      setAdminEquipSnoId(record.equipmentId);

      if (categoryData && categoryData.length > 0 && record.pihEquipmentTypeCategory) {
        const equipArr = categoryData.filter(
          (item) => item.pihEquipmentTypeCategory == record.pihEquipmentTypeCategory
        );
        const arr = [...new Map(equipArr.map((item) => [item.pihEquipmentType, item])).values()];
        arr.sort((a, b) =>
          a.pihEquipmentType.toLowerCase().localeCompare(b.pihEquipmentType.toLowerCase())
        );
        setAdminEquipmentTypes(arr);
        const equipmentTypeRow = categoryData.find(
          (u) => u.pihEquipmentType === record.pihEquipmentType
        );
        if (equipmentTypeRow) setAdminEquipTypeId(equipmentTypeRow.id);
      }

      await onGetEquipSno({
        pihEquipmentTypeCategory: record.pihEquipmentTypeCategory,
        pihEquipmentType: record.pihEquipmentType,
      });
      await onGetAdminMaintenanceTypesById({ id: record.equipmentId });
      await onGetEquipMaintenanceInterval(record.id);
    }
    equipmentFormData.setFieldsValue(editData);
    setEquipTitle('Update Equipment Data');
    setEditValue(true);
    setIsEquipmentModalVisible(true);
    setSelectedEquipment(true);
  };

  /** Display Confirmation while deleting */
  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };

  /** Deleting Equipment data on confirm */
  const handleDeleteOk = async () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const payload = {
      ...selectedData,
      projectId: selectedProject.id,
      deletedBy: user?.email || '',
    };
    await onDeleteEquipDetails({ data: payload });
  };

  /** Cancelling the deletion of euqipment data */
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData('');
  };

  /** Close modal & delete values after confirmation equipment details */
  useEffect(() => {
    if (!isEquipDeleteLoading) {
      setIsDeleteModalVisible(false);
      setSelectedData('');
    }
  }, [isEquipDeleteLoading]);

  /** Show modal to add new equipment details */
  const showModal = () => {
    if (selectedProject && selectedProject.id) {
      setEditValue(false);
      setIsEquipmentModalVisible(true);
      setEquipTitle('Add New Equipment Data');
      setSerialNoList([]);
      equipmentFormData.resetFields();
      setPihEquipment('');
      setSerialNo('');
      setAdminEquipSnoId(undefined);
      //for check box
      setCheckedList(adminMaintenanceTypesList);
      setCheckAll(true);
      setSelectedEquipment(false);
      setAdminEquipmentTypes([]);
      equipmentFormData.setFieldsValue({ assignSpares: false, quantity: 1 });
      setAssignSpares(false);
    } else {
      notification.warning({
        message: 'Please select Project to Add Equipment',
      });
    }
  };

  /** Cloase modal on cancel */
  const handleCancel = () => {
    setIsEquipmentModalVisible(false);
    equipmentFormData.resetFields();
    setEditValue(false);
    setSerialNoList([]);
    // equipmentFormData.resetFields();
    setPihEquipment('');
    setSerialNo('');
    setAdminEquipSnoId(undefined);
    //for check box
    setCheckedList(adminMaintenanceTypesList);
    setCheckAll(true);
    setSelectedEquipment(false);
    setPihCategory('');
    setLoadUpdate(false);
  };

  /** Function to Add or Update equipment details */
  const handleOk = () => {
    equipmentFormData.validateFields().then(async (data) => {
      if (data.pihEquipment && data.serialNo) {
        if (!editValue) {
          // Check condition for assignSpares and quantity
          if (data.assignSpares && (!data.quantity || data.quantity <= 0)) {
            notification.warning({
              message: 'Please add quantity to proceed!',
            });
            return; // Exit the function without making the API call
          }

          // Construct sparePartOptions based on assignSpares and quantity
          let sparesObj = {
            assignSpares: Boolean(data.assignSpares),
            quantity: data.assignSpares ? Number(data.quantity) : 0,
          };

          var obj = {
            projectId: selectedProject.id,
            equipmentId: adminEquipSnoId,
            sparePartOptions: sparesObj,
          };

          var listArray = [];
          if (checkAll && checkedList.length > 0) {
            // All Maintenance Types Selected
            adminMaintenanceTypesById.forEach((item) => {
              listArray.push(item.id);
            });

            obj.configuredMaintenanceTypes = listArray;

            await onAddEquipData(obj);
          } else if (checkedList.length > 0) {
            // Specific Maintenance Types Selected
            for (let i = 0; i < adminMaintenanceTypesById.length; i++) {
              for (let j = 0; j < checkedList.length; j++) {
                if (adminMaintenanceTypesById[i].name === checkedList[j]) {
                  listArray.push(adminMaintenanceTypesById[i].id);
                }
              }
            }
            obj.configuredMaintenanceTypes = listArray;

            await onAddEquipData(obj);
          } else {
            notification.warning({
              message: 'Select at least one Maintenance Type to proceed!',
            });
          }
        } else {
          // Update PIH Equipment
          if (equipId) {
            if (!adminEquipSnoId) {
              notification.warning({
                message: 'Select Serial No. / Location to proceed!',
              });
              return;
            }
            var obj = {
              pihEquipment: {
                usageStatus: equipId.usageStatus,
                equipmentId: adminEquipSnoId,
              },
            };
            var listArray = [];
            if (checkAll && checkedList.length > 0) {
              // All Maintenance Types Selected
              adminMaintenanceTypesById.forEach((item) => {
                listArray.push(item.id);
              });

              obj.pihEquipment.configuredMaintenanceTypes = listArray;

              await onUpdateEquipData({
                data: obj,
                id: equipId.id,
                projectId: selectedProject.id,
              });
            } else if (checkedList.length > 0) {
              // Specific Maintenance Types Selected
              for (let i = 0; i < adminMaintenanceTypesById.length; i++) {
                for (let j = 0; j < checkedList.length; j++) {
                  if (adminMaintenanceTypesById[i].name === checkedList[j]) {
                    listArray.push(adminMaintenanceTypesById[i].id);
                  }
                }
              }
              obj.pihEquipment.configuredMaintenanceTypes = listArray;

              await onUpdateEquipData({
                data: obj,
                id: equipId.id,
                projectId: selectedProject.id,
              });
            }
          } else {
            notification.warning({
              message: 'Unable to process your request. Close Window and try again!',
            });
          }
        }
      } else {
        notification.warning({
          message: 'Fill all the required fields!',
        });
      }
    });
  };

  /** Close modal & reset values after adding equipment details */
  useEffect(() => {
    if (!isEquipDetailsLoading) {
      equipmentFormData.resetFields();
      setIsEquipmentModalVisible(false);
      setEditValue(false);
      setSelectedEquipment(false);
    }
  }, [isEquipDetailsLoading]);

  /** Close modal & reset values after updating equipment details */
  useEffect(() => {
    if (!isEquipUpdateLoading) {
      equipmentFormData.resetFields();
      setIsEquipmentModalVisible(false);
      setEditValue(false);
      setEquipId(null);
    }
  }, [isEquipUpdateLoading]);

  /** Setting Serial Number list on equipment details */
  useEffect(() => {
    setSerialNoList(adminEquipSnoData);
  }, [adminEquipSnoData]);

  /** Remove duplicates from the PIH equipment Category */
  const RemoveDuplicates = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };

  /** Making PIH Equipment Category list unique by removing duplicates */
  useEffect(() => {
    if (categoryData && categoryData.length > 0) {
      var arr = RemoveDuplicates(categoryData, 'pihEquipmentTypeCategory');

      var filteredArr = arr.filter(function (el) {
        return el.pihEquipmentTypeCategory != null;
      });

      //make array of category in alphabetical order
      filteredArr.sort((a, b) =>
        a.pihEquipmentTypeCategory
          .toLowerCase()
          .localeCompare(b.pihEquipmentTypeCategory.toLowerCase())
      );

      //making array Camel Case and string which are enclosed in brases () to UPPERCASE
      for (let i = 0; i < filteredArr.length; i++) {
        filteredArr[i].category = titleCase(filteredArr[i].pihEquipmentTypeCategory);
      }

      setCategoryDataList(filteredArr);
    } else {
      setCategoryDataList([]);
    }
  }, [categoryData]);

  /** Setting the equipment sub category */
  // useEffect(() => {
  //   setAdminEquipmentTypes(adminDocumentSubTypeSnoData);
  // }, [adminDocumentSubTypeSnoData])

  /** Function to make category list in alphabetical order */
  const titleCase = (str) => {
    if (str !== null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      var stringUpperLowerCase = splitStr.join(' ');

      //After joining the string making string to uppercase which are enclosed in brases ()
      const result = capitalCase(stringUpperLowerCase);

      return result;
    } else {
      return str;
    }
  };

  /** Function to make category list in UPPERCASE which are enclosed in brases() */
  const capitalCase = (str) => {
    const result = str
      .split(' ')
      .map((s) =>
        s.startsWith('(') && s.endsWith(')')
          ? s.toUpperCase()
          : s.slice(0, 1).toUpperCase() + s.slice(1)
      )
      .join(' ');
    return result;
  };

  /** On change function to select Category */
  const onChangeCategory = async (value) => {
    equipmentFormData.setFieldsValue({ serialNo: '', pihEquipment: '' });
    setSerialNo('');
    setPihEquipment('');
    setAdminEquipmentTypes([]);
    if (value) {
      setPihCategory(value);
      var equipArr =
        categoryData && categoryData.filter((item) => item.pihEquipmentTypeCategory == value);

      //remove duplicates
      var arr = RemoveDuplicates(equipArr, 'pihEquipmentType');
      //make array of equipment in alphabetical order
      arr.sort((a, b) =>
        a.pihEquipmentType.toLowerCase().localeCompare(b.pihEquipmentType.toLowerCase())
      );
      // await onFetchAdminDocumentSubTypeSno({ pihEquipmentTypeCategory: value });
      setAdminEquipmentTypes(arr);
      // await onGetAdminEquipmentTypes({ pihEquipmentType: value });
    } else {
      setSerialNoList([]);
      setPihEquipment('');
      setSerialNo('');
      setSelectedEquipment(false);
      setPihCategory('');
      setAdminEquipmentTypes([]);
    }
  };
  /** On change function to select Equipment */
  const onChangeEquipmentType = async (value) => {
    equipmentFormData.setFieldsValue({ serialNo: '' });
    setSerialNo('');
    if (value) {
      // const equipmentTypeId = adminEquipmentTypes.find(u => u.name === value);
      const equipmentTypeId = categoryData.find((u) => u.pihEquipmentType === value);
      setAdminEquipTypeId(equipmentTypeId.id);
      setPihEquipment(value);
      // setSelectedEquipment(true);
      await onGetEquipSno({ pihEquipmentTypeCategory: pihCategory, pihEquipmentType: value });
      // await onGetAdminMaintenanceTypesById({ id: equipmentTypeId.id });
    } else {
      setSerialNoList([]);
      setPihEquipment('');
      setSerialNo('');
      setSelectedEquipment(false);
    }
  };

  /** On change function to select Equipment Sno */
  const onChangeEquipmentSno = async (value) => {
    if (value) {
      const equipmentSnoId = serialNoList.find((u) => u.serialNumber === value);
      setAdminEquipSnoId(equipmentSnoId.id);
      setSerialNo(value);
      setSelectedEquipment(true);
      await onGetAdminMaintenanceTypesById({ id: equipmentSnoId.id });
    } else {
      setSerialNo('');
      setAdminEquipSnoId('');
      setSelectedEquipment(false);
    }
  };

  const onSearch = (value, id) => {
    console.log('search:', value, id);
  };

  const onAddNewEquipment = (event) => {
    setNewEquipment(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    if (!isEmpty(newEquipment) && !isEmpty(newEquipment.trim())) {
      const equipmentObj = {
        name: newEquipment,
      };
      //   onAddClient(roleData);
      setNewEquipment('');

      //for local only
      var arr = [...equipmentList];
      arr.push(equipmentObj);
      setEquipmentList(arr);
    }
  };

  const removeItem = (e) => {
    e.preventDefault();
    setNewEquipment('');
  };

  /** Close Modal on close of table details */
  const handleCancelTable = () => {
    setIsTableModelVisible(false);
    setDailyActive('');
    setWeeklyActive('');
    setMonthlyActive('');
    setSelectedDateInput(null);
    setActiveKey('');
    setChecksData([]);
    setChecksDataLog([]);
    setClickedTableData(false);
    setHistoryCurrentPage(1);
  };

  /**Open checks table / Modal on view of checks (double click on row disabled)  */
  const handleEyeClick = async (record) => {
    setChecksData([]);
    setChecksDataLog([]);
    setIsTableModelVisible(true);
    setHistoryCurrentPage(1);
    // setCalenderView('day');
    // setDailyActive('active');
    setEquipmentLogs(record);
    var todaysDate = moment();

    // setSelectedDateInput(todaysDate);
    var obj = {
      pihEquipmentId: record.id,
      fromDate: moment(todaysDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      toDate: moment(todaysDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      // checkIntervalId: '',
      // typeOfMaintenanceId: ''
    };
    // await ongetChecksData(obj);
    equipmentLogsForm.resetFields();
    await onGetEquipMaintenanceInterval(record.id);
    // await onGetCheckIntervals();
  };

  /** Setting maintenance types for specific pih equipments */
  useEffect(() => {
    var arr = [];
    if (equipMaintenanceIntervalData.length > 0) {
      //for pih equipment logs (history view of checks)
      setConfiguredMaintenanceTypes(equipMaintenanceIntervalData);
      //default select first maintenance type
      setPihMaintenanceType(equipMaintenanceIntervalData[0]);
      equipmentLogsForm.setFieldsValue({
        pihMaintenanceType: equipMaintenanceIntervalData[0].name,
      });
      setIntervalListData(equipMaintenanceIntervalData[0].check_intervals);

      var intervalTab = equipMaintenanceIntervalData[0].check_intervals[0].name.toLowerCase();
      var dateInterval;

      //set maintenance and interval ID
      setIntervalIdCheck(equipMaintenanceIntervalData[0].check_intervals[0].id);
      setMaintenanceIdCheck(equipMaintenanceIntervalData[0].id);

      //for tab selection
      setActiveKey(intervalTab);
      //for calender view
      if (intervalTab === ('daily' || 'day')) {
        setCalenderView('day');
        dateInterval = 'day';
      } else if (intervalTab === ('weekly' || 'week')) {
        setCalenderView('week');
        dateInterval = 'week';
      } else if (intervalTab === ('monthly' || 'month')) {
        setCalenderView('month');
        dateInterval = 'month';
      } else if (intervalTab === ('quarterly' || 'quarter')) {
        setCalenderView('quarter');
        dateInterval = 'quarter';
      } else if (intervalTab === ('yearly' || 'year')) {
        setCalenderView('year');
        dateInterval = 'year';
      } else {
        setCalenderView('custom');
        dateInterval = 'day';
      }
      var todaysDate = moment();
      //for calender date input
      // setSelectedDateInput(null);
      // console.log(equipmentLogs, equipMaintenanceIntervalData[0].check_intervals[0], equipMaintenanceIntervalData[0])
      // console.log('equipMaintenanceIntervalData.......', equipMaintenanceIntervalData);

      var obj = {
        pihEquipmentId: equipmentLogs.id,
        // fromDate: moment(todaysDate).startOf(dateInterval).format('YYYY-MM-DD HH:mm:ss'),
        // toDate: moment(todaysDate).endOf(dateInterval).format('YYYY-MM-DD HH:mm:ss'),
        checkIntervalId: equipMaintenanceIntervalData[0].check_intervals[0].id,
        typeOfMaintenanceId: equipMaintenanceIntervalData[0].id,
      };
      // if (['LOLER EX']equipMaintenanceIntervalData[0]?.name === 'LOLER EXAMINATION' || equipMaintenanceIntervalData[0]?.name === 'REFURB CHECKLIST' || equipMaintenanceIntervalData[0]?.name === 'BUILD CHECKLIST') {
      if (['LOLER EXAMINATION', 'REFURB CHECKLIST', 'BUILD CHECKLIST'].includes(equipMaintenanceIntervalData[0]?.name)) {
        obj.isOverallMaintenanceHistory = true;
        obj.equipmentId = equipmentLogs?.equipmentId;
      }
      //get checks details on view
      if (obj.pihEquipmentId && obj.checkIntervalId && obj.typeOfMaintenanceId) {
        // ongetChecksData(obj);
        onGetChecksLogs(obj);
      }

      // //for updating pih equipment view
      // for (let i = 0; i < equipMaintenanceIntervalData.length; i++) {
      //   arr.push(equipMaintenanceIntervalData[i].name)
      // }

      // //for Updating PIH Equipment
      // setCheckedList(arr);
      // setAdminMaintenanceTypesList(arr);
    }
  }, [equipMaintenanceIntervalData]);

  /** Setting Maintenance types while updating the pih equipment */
  useEffect(
    () => {
      var arrList = [];
      var arr = [];
      if (editValue) {
        // console.log("NEW changes");
        for (let i = 0; i < adminMaintenanceTypesById.length; i++) {
          arr.push(adminMaintenanceTypesById[i].name);
          for (let j = 0; j < equipMaintenanceIntervalData.length; j++) {
            if (adminMaintenanceTypesById[i].name === equipMaintenanceIntervalData[j].name) {
              arrList.push(adminMaintenanceTypesById[i].name);
            }
          }
        }
        // console.log(arrList, arr);
        setAdminCompare(arrList);
        setCheckedList(arrList);
        setAdminMaintenanceTypesList(arr);
        setCheckAll(arrList.length === adminMaintenanceTypesById.length);
      }
    },
    [adminMaintenanceTypesById],
    [equipMaintenanceIntervalData]
  );

  /** Setting Admin Maintenance Types Data on Load */
  useEffect(() => {
    var arr = [];
    if (selectedEquipment && !editValue) {
      // console.log("OLD changes");
      if (adminMaintenanceTypesById.length > 0) {
        for (let i = 0; i < adminMaintenanceTypesById.length; i++) {
          arr.push(adminMaintenanceTypesById[i].name);
        }
        setCheckedList(arr);
        setAdminMaintenanceTypesList(arr);
      } else {
        setCheckedList([]);
        setAdminMaintenanceTypesList([]);
      }
    }
  }, [adminMaintenanceTypesById]);

  /** Getting details on double click on table row */
  useEffect(() => {
    if (checksDetails && checksDetails.length > 0) {
      setChecksData(checksDetails);
    } else {
      setChecksData([]);
    }
  }, [checksDetails]);

  /** Getting details on double click on table row */
  useEffect(() => {
    if (checksDetailsLog && checksDetailsLog.length > 0) {
      setChecksDataLog(checksDetailsLog);
    } else {
      setChecksDataLog([]);
    }
  }, [checksDetailsLog]);

  const onChangeCheckBox = (list) => {
    setCheckedList(list);
    setCheckAll(list.length === adminMaintenanceTypesList.length);
  };

  const equipmentSearchFiltered = useMemo(
    () => (equipDetails || []).map((r) => enrichEquipmentRowForFacets({ ...r })),
    [equipDetails]
  );

  const handleHeatColumnFilterChange = useCallback((key, value) => {
    setHeatColumnFilters((prev) => ({ ...prev, [key]: value }));
    setCurrent(1);
  }, []);

  const equipmentFacetRef = useRef([]);
  equipmentFacetRef.current = equipmentSearchFiltered;
  const fetchEquipmentFacetRows = useCallback(async () => {
    const list = equipmentFacetRef.current;
    return Array.isArray(list) ? [...list] : [];
  }, []);

  const equipmentFacetSearchCriteria = useMemo(() => ({}), []);

  const { applyFacetClientFilter, renderTextColumnFilterTrigger } = useHeatStyleColumnFacets({
    enabled: Boolean(projectIdValue),
    filterableColumns: EQUIPMENT_FACET_KEYS,
    listCount: equipmentSearchFiltered.length,
    projectList: equipmentSearchFiltered,
    searchCriteria: equipmentFacetSearchCriteria,
    columnFilters: heatColumnFilters,
    onColumnFilterChange: handleHeatColumnFilterChange,
    fetchFacetRows: fetchEquipmentFacetRows,
  });

  const lc = (v) => (v == null ? '' : String(v)).trim().toLowerCase();

  const filteredAndFacetedEquipment = useMemo(() => {
    let list = [...equipmentSearchFiltered];
    EQUIPMENT_FACET_KEYS.forEach((key) => {
      const raw = (heatColumnFilters[key] || '').trim();
      if (!raw) return;
      const q = lc(raw);
      list = list.filter((row) => lc(get(row, key)).includes(q));
    });
    return applyFacetClientFilter(list);
  }, [equipmentSearchFiltered, heatColumnFilters, applyFacetClientFilter]);

  const handleEquipmentSortClick = useCallback((field) => {
    setEquipmentSort((prev) =>
      prev.key === field ? { ...prev, desc: !prev.desc } : { key: field, desc: false }
    );
  }, []);

  const renderEquipmentSortCaret = useCallback(
    (field) =>
      equipmentSort.key === field ? (
        equipmentSort.desc ? (
          <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        ) : (
          <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        )
      ) : (
        <CaretUpOutlined
          className="equipment-type-sort-dir-icon doc-control-sort-caret-inactive"
          aria-hidden
        />
      ),
    [equipmentSort.key, equipmentSort.desc]
  );

  const renderEquipmentHeader = useCallback(
    (labelNode, dataIndex, sortField, { filterable = true, headerAlign = 'center' } = {}) => {
      if (!filterable) {
        return (
          <div className="column-header-with-filter column-header-with-filter--no-search">
            <div
              className={`column-header-text-wrapper dpr-pipelines-heat-title-row${
                headerAlign === 'left' ? ' dpr-pipelines-heat-title-row--left' : ''
              }`}
            >
              <span className="dpr-pipelines-heat-label">{labelNode}</span>
            </div>
          </div>
        );
      }
      return (
        <div className="column-header-with-filter">
          <div
            className={`column-header-text-wrapper spares-column-header-sortable dpr-pipelines-heat-title-row${
              headerAlign === 'left' ? ' dpr-pipelines-heat-title-row--left' : ''
            }`}
          >
            <span
              className="dpr-pipelines-heat-label dpr-pipelines-heat-label--sortable"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                handleEquipmentSortClick(sortField);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleEquipmentSortClick(sortField);
                }
              }}
            >
              {labelNode}
            </span>
            <span
              className="custom-sort-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleEquipmentSortClick(sortField);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleEquipmentSortClick(sortField);
                }
              }}
            >
              {renderEquipmentSortCaret(sortField)}
            </span>
            {renderTextColumnFilterTrigger(dataIndex)}
          </div>
          <div className="header-filter-input user-mgmt-header-search">
            <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
              <Input
                placeholder="Search"
                value={heatColumnFilters[dataIndex] ?? ''}
                onChange={(e) => handleHeatColumnFilterChange(dataIndex, e.target.value)}
                onClick={(e) => e.stopPropagation()}
                size="small"
                style={{ width: 120 }}
              />
            </div>
          </div>
        </div>
      );
    },
    [
      handleEquipmentSortClick,
      handleHeatColumnFilterChange,
      heatColumnFilters,
      renderEquipmentSortCaret,
      renderTextColumnFilterTrigger,
    ]
  );

  const sortedEquipmentDisplayList = useMemo(() => {
    const list = [...filteredAndFacetedEquipment];
    const cmpStr = (a, b, key) =>
      String(get(a, key) ?? '')
        .trim()
        .toLowerCase()
        .localeCompare(String(get(b, key) ?? '').trim().toLowerCase(), undefined, {
          sensitivity: 'base',
          numeric: true,
        });
    const cmpUsage = (a, b) => {
      const ua = a?.usageStatus === 1 ? 2 : a?.usageStatus === 2 ? 1 : 0;
      const ub = b?.usageStatus === 1 ? 2 : b?.usageStatus === 2 ? 1 : 0;
      return ua - ub;
    };
    const tieBreak = (a, b) => {
      const idA = a?.id != null ? Number(a.id) : NaN;
      const idB = b?.id != null ? Number(b.id) : NaN;
      if (Number.isFinite(idA) && Number.isFinite(idB) && idA !== idB) {
        return idA < idB ? -1 : 1;
      }
      return String(a?.id ?? '').localeCompare(String(b?.id ?? ''), undefined, { numeric: true });
    };
    const { key: sortKey, desc: sortDesc } = equipmentSort;
    list.sort((a, b) => {
      let cmp = 0;
      switch (sortKey) {
        case 'pihEquipmentTypeCategory':
        case 'pihEquipmentType':
        case 'serialNumber':
        case 'description':
        case '__usageStatusLabel':
          cmp = cmpStr(a, b, sortKey);
          break;
        case 'usageStatus':
          cmp = cmpUsage(a, b);
          break;
        default:
          cmp = 0;
      }
      if (cmp === 0) cmp = tieBreak(a, b);
      return sortDesc ? -cmp : cmp;
    });
    return list;
  }, [filteredAndFacetedEquipment, equipmentSort]);

  const equipmentPagedRows = useMemo(() => {
    const start = (current - 1) * pageSize;
    return sortedEquipmentDisplayList.slice(start, start + pageSize);
  }, [sortedEquipmentDisplayList, current, pageSize]);

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const columns = useMemo(
    () => [
      {
        title: renderEquipmentHeader('#', null, null, { filterable: false, headerAlign: 'center' }),
        dataIndex: 'sno',
        key: 'sno',
        align: 'center',
        width: 48,
        className: 'equip-col-sn',
        onHeaderCell: () => ({ className: 'equip-col-sn' }),
        render: (text, record, index) => (current - 1) * pageSize + index + 1,
      },
      {
        title: renderEquipmentHeader(
          'Equipment category',
          'pihEquipmentTypeCategory',
          'pihEquipmentTypeCategory',
          { headerAlign: 'left' }
        ),
        dataIndex: 'pihEquipmentTypeCategory',
        key: 'pihEquipmentTypeCategory',
        width: 220,
        ellipsis: { showTitle: true },
        render: (address) => (
          <Tooltip placement="topLeft" title={address}>
            {address}
          </Tooltip>
        ),
      },
      {
        title: renderEquipmentHeader(
          'Equipment subcategory',
          'pihEquipmentType',
          'pihEquipmentType',
          { headerAlign: 'left' }
        ),
        dataIndex: 'pihEquipmentType',
        key: 'pihEquipmentType',
        width: 220,
        ellipsis: { showTitle: true },
        render: (address) => (
          <Tooltip placement="topLeft" title={address}>
            {address}
          </Tooltip>
        ),
      },
      {
        title: renderEquipmentHeader(
          'Serial number',
          'serialNumber',
          'serialNumber',
          { headerAlign: 'left' }
        ),
        dataIndex: 'serialNumber',
        key: 'serialNumber',
        align: 'left',
        width: 180,
        ellipsis: { showTitle: true },
        render: (address) => (
          <Tooltip placement="topLeft" title={address}>
            {address}
          </Tooltip>
        ),
      },
      {
        title: renderEquipmentHeader(
          'Description',
          'description',
          'description',
          { headerAlign: 'left' }
        ),
        dataIndex: 'description',
        key: 'description',
        align: 'left',
        width: 280,
        ellipsis: { showTitle: true },
        render: (address) => (
          <Tooltip placement="topLeft" title={address}>
            {address}
          </Tooltip>
        ),
      },
      {
        title: renderEquipmentHeader('Status', '__usageStatusLabel', 'usageStatus'),
        key: 'usageStatus',
        dataIndex: 'usageStatus',
        width: 140,
        align: 'center',
        render: (_, record) => {
          const title =
            record.usageStatus === 1 ? 'In use' : record.usageStatus === 2 ? 'In backup' : '—';
          const cls =
            record.usageStatus === 1
              ? 'is-in-use'
              : record.usageStatus === 2
                ? 'is-backup'
                : 'is-idle';
          return (
            <Tooltip title={title}>
              <span className={`equip-status-dot ${cls}`}>
                <span className="equip-status-dot-inner" aria-hidden />
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: renderEquipmentHeader('Actions', null, null, {
          filterable: false,
          headerAlign: 'center',
        }),
        key: 'actions',
        width: 136,
        align: 'center',
        className: 'equip-col-actions',
        onHeaderCell: () => ({ className: 'equip-col-actions' }),
        render: (_, record) => (
          <div className="ship-actions-cell">
            <Tooltip title="View checks">
              <button
                type="button"
                className="ship-action-btn"
                aria-label="View checks"
                onClick={() => handleEyeClick(record)}
              >
                <Eye size={18} strokeWidth={1.75} />
              </button>
            </Tooltip>
            <Tooltip title="Edit">
              <button
                type="button"
                className="ship-action-btn"
                aria-label="Edit equipment"
                disabled={isWriteAccess}
                onClick={() => {
                  if (!isWriteAccess) showEditModal(record);
                }}
              >
                <Pencil size={18} strokeWidth={1.75} />
              </button>
            </Tooltip>
            <Tooltip title="Delete">
              <button
                type="button"
                className="ship-action-btn ship-action-btn--delete"
                aria-label="Delete equipment"
                disabled={isWriteAccess}
                onClick={() => {
                  if (!isWriteAccess) showDeleteModal(record);
                }}
              >
                <Trash2 size={18} strokeWidth={1.75} />
              </button>
            </Tooltip>
          </div>
        ),
      },
    ],
    [renderEquipmentHeader, current, pageSize, isWriteAccess, handleEyeClick, showEditModal, showDeleteModal]
  );

  return (
    <div className="modern-equipment-page">
      <div className="equip-header">
        <div className="equip-header-left">
          <div className="equip-header-icon">
            <Wrench size={24} color="#2563eb" strokeWidth={1.75} aria-hidden />
          </div>
          <div className="equip-header-titles">
            <h1 className="equip-title">Equipment</h1>
            <p className="equip-subtitle">List and manage equipment assigned to this project.</p>
          </div>
        </div>
        <div className="equip-header-actions">
          <CrceButton
            label="Add new"
            variant="primary"
            size="small"
            icon={Plus}
            onClick={() => {
              if (!isWriteAccess) showModal();
            }}
            disabled={isWriteAccess}
          />
        </div>
      </div>

      <div className="equip-table-shell dpr-settings-pipelines-table-wrap">
        <Table
          columns={columns}
          dataSource={equipmentPagedRows}
          className="equipment-dashboard-table project-tab-heat-table"
          rowKey={(r) => r.id ?? r.serialNumber}
          scroll={{ x: 1484 }}
          pagination={
            sortedEquipmentDisplayList.length > 0
              ? {
                  position: ['bottomCenter'],
                  className: 'heat-profile-pagination',
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '50', '100'],
                  showTotal: (total, range) => `${range[0]}–${range[1]} of ${total} items`,
                  total: sortedEquipmentDisplayList.length,
                  pageSize,
                  current,
                  onChange: (pageNumber, newPageSize) => {
                    setCurrent(pageNumber);
                    setPageSize(newPageSize);
                  },
                }
              : false
          }
          loading={getProjectTableLoadingConfig(isGetEquipDetailsLoading)}
          locale={{ emptyText: <ProjectTabTableEmpty /> }}
        />
      </div>

      {isEquipmentModalVisible && (
        <div className="mc-dpr-modal-backdrop" role="presentation">
          <div
            className="mc-dpr-modal mc-dpr-modal--large mc-dpr-modal--equip-form"
            role="dialog"
            aria-labelledby="equip-form-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mc-dpr-modal-head">
              <h3 id="equip-form-modal-title" className="mc-dpr-modal-title">
                {equipTitle}
              </h3>
              <button type="button" className="mc-dpr-modal-close" aria-label="Close" onClick={handleCancel}>
                <X size={20} />
              </button>
            </div>
            <div className="mc-dpr-modal-body">
        <div>
          {loadUpdate ? (
            <Skeleton active />
          ) : (
            <Form
              form={equipmentFormData}
              name="basic"
              layout="vertical"
              autoComplete="off"
              getcontainer={false}
              onValuesChange={(changed) => {
                if ('assignSpares' in changed) {
                  setAssignSpares(changed.assignSpares);
                }
              }}
            >
              <Row gutter={24}>
                <Col lg={12}>
                  <Form.Item
                    label="Equipment Category"
                    name="pihCategory"
                    required
                  >
                    <Select
                      placeholder="Select Equipment Category"
                      showArrow
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      onChange={onChangeCategory}
                      getPopupContainer={getPopupContainerBody}
                      dropdownClassName="mc-dpr-modal-select-dd"
                    >
                      {categoryDataList &&
                        categoryDataList.map((item, i) => (
                          <Option
                            key={i}
                            value={item && item.pihEquipmentTypeCategory}
                          >
                            {item && item.category}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={12}>
                  <Form.Item
                    label="Equipment Subcategory"
                    name="pihEquipment"
                    required
                  >
                    <Select
                      placeholder="Select Equipment Subcategory"
                      showArrow
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      onChange={onChangeEquipmentType}
                      getPopupContainer={getPopupContainerBody}
                      dropdownClassName="mc-dpr-modal-select-dd"
                    >
                      {/* {adminDocumentSubCategoryLoad && <Option key={'loading'} value={'Loading...'} />} */}
                      {adminEquipmentTypes &&
                        adminEquipmentTypes.map((item, i) => (
                          <Option
                            key={i}
                            value={item && item.pihEquipmentType}
                          >
                            {item && item.pihEquipmentType}
                          </Option>
                        ))}
                      {/* <Option key={i} value={item && item.equipmentType}>{item && item.equipmentType}</Option>)} */}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={12}>
                  <Form.Item
                    label="Serial No. / Location"
                    name="serialNo"
                    required
                  >
                    <Select
                      placeholder={adminEquipSnoLoading ? 'Loading...' : 'Select Sl.No.'}
                      showArrow
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      onChange={onChangeEquipmentSno}
                      disabled={!pihEquipment}
                      getPopupContainer={getPopupContainerBody}
                      dropdownClassName="mc-dpr-modal-select-dd"
                    >
                      {adminEquipSnoLoading && (
                        <Option
                          key={'loading'}
                          value={'Loading...'}
                        />
                      )}
                      {!adminEquipSnoLoading &&
                        serialNoList &&
                        serialNoList.map((item, i) => (
                          <Option
                            key={i}
                            value={item && item.serialNumber}
                          >
                            {item && item.serialNumber}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* <Col lg={12}>
                  <Form.Item
                    name="serialNo"
                    required
                  >

                  </Form.Item>
                </Col> */}
                {!editValue && (
                  <Col lg={24}>
                    <Form.Item
                      label="Assign Spares"
                      name="assignSpares"
                      required
                      className="equip-assign-spares"
                    >
                      <Radio.Group className="equip-assign-spares__group">
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                )}

                {!editValue && assignSpares && (
                  <Col lg={6}>
                    <Form.Item
                      label="Quantity"
                      name="quantity"
                      required
                    >
                      <Input
                        placeholder={'Quantity'}
                        value={quantity}
                        // defaultValue={1}
                        onChange={(e) => setQuantity(e.target.value)}
                        onKeyPress={handleKeyPress}
                        min={1}
                        type="number"
                        size="large"
                      />
                    </Form.Item>
                  </Col>
                )}
                {/* <Col lg={12}>
                <Form.Item
                  label="Planned"
                  name="planned"
                  required
                >
                  <InputNumber
                    type="number"
                    value={planned}
                    onChange={(e) => setPlanned(e)}
                    size="large" />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  label="Back up"
                  name="backup"
                  required
                >
                  <InputNumber
                    type="number"
                    value={backup}
                    onChange={(e) => setBackup(e)}
                    size="large" />
                </Form.Item>
              </Col> */}
                <Col lg={24}>
                  <Form.Item
                    label="Maintenance Type"
                    className="equip-maintenance-types"
                    // name="maintenanceType"
                    required
                  >
                    {/* <Select
                    className='maintenance-select'
                    placeholder='Select one or more Maintenance Types...'
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={e => setMaintenanceType(e)}
                    mode="multiple"
                  >
                    {adminMaintenanceTypesList && adminMaintenanceTypesList.map((item, i) =>
                      <Option key={i} value={item && item.name}>{item && item.name}</Option>)
                    }
                  </Select> */}
                    {typesLoading ? (
                      <Text>Loading...</Text>
                    ) : (
                      <>
                        {selectedEquipment ? (
                          <>
                            {adminMaintenanceTypesList.length > 0 ? (
                              <>
                                <div className="equip-maintenance-types-select-all">
                                  <CrceCheckbox
                                    label="Select all"
                                    checked={checkAll}
                                    disabled={editValue && adminCompare.length > 0}
                                    borderColor="#00C9A7"
                                    onChange={(checked) => {
                                      setCheckedList(checked ? [...adminMaintenanceTypesList] : []);
                                      setCheckAll(checked);
                                    }}
                                  />
                                </div>
                                <div className="equip-maintenance-types-divider" aria-hidden />
                                <div
                                  className="equip-maintenance-types-checkbox-group"
                                  role="group"
                                  aria-label="Maintenance types"
                                >
                                  {adminMaintenanceTypesList.map((item, mtIdx) => (
                                    <CrceCheckbox
                                      key={`${item}-${mtIdx}`}
                                      label={item}
                                      checked={checkedList.includes(item)}
                                      disabled={
                                        editValue && !!adminCompare.find((data) => data === item)
                                      }
                                      borderColor="#00C9A7"
                                      onChange={(checked) => {
                                        const next = checked
                                          ? Array.from(new Set([...checkedList, item]))
                                          : checkedList.filter((x) => x !== item);
                                        onChangeCheckBox(next);
                                      }}
                                    />
                                  ))}
                                </div>
                              </>
                            ) : (
                              <Text>
                                {adminMaintenanceTypesList &&
                                  adminMaintenanceTypesList.length === 0 &&
                                  '---- No Data ----'}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text>Select Serial No. / Location to select Maintenance Types</Text>
                        )}
                      </>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </div>
            </div>
            <div className="mc-dpr-modal-foot">
              <CrceButton label="Cancel" variant="tertiary" size="medium" onClick={handleCancel} />
              <CrceButton
                label={
                  !editValue
                    ? isEquipDetailsLoading
                      ? 'Adding…'
                      : 'Add'
                    : isEquipUpdateLoading
                      ? 'Updating…'
                      : 'Update'
                }
                variant="primary"
                size="medium"
                onClick={handleOk}
                disabled={isEquipDetailsLoading || isEquipUpdateLoading}
              />
            </div>
          </div>
        </div>
      )}

      {isTableModelVisible && (
        <div className="mc-dpr-modal-backdrop" role="presentation">
          <div
            className="mc-dpr-modal mc-dpr-modal--equip-logs mc-dpr-modal--equip-logs-wide"
            role="dialog"
            aria-labelledby="equip-logs-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mc-dpr-modal-head mc-dpr-modal-head--equip-logs">
              <h3
                id="equip-logs-modal-title"
                className="mc-dpr-modal-title equip-logs-modal-title"
              >
                Equipment checks — {equipmentLogs?.pihEquipmentType || equipmentLogs?.name || '—'} (
                {equipmentLogs?.serialNumber || '—'})
              </h3>
              <div className="equip-logs-modal-head-actions">
                <div
                  ref={equipLogsDateHeaderSlotRef}
                  className="equip-logs-modal-date-slot"
                  aria-label="Date filter"
                />
                <button
                  type="button"
                  className="mc-dpr-modal-close"
                  aria-label="Close"
                  onClick={handleCancelTable}
                >
                  <X size={20} />
                </button>
              </div>
            </div>
            <div className="mc-dpr-modal-body">
        <EquipmentLogs
          dailyActive={dailyActive}
          setDailyActive={setDailyActive}
          weeklyActive={weeklyActive}
          setWeeklyActive={setWeeklyActive}
          monthlyActive={monthlyActive}
          setMonthlyActive={setMonthlyActive}
          selectedProject={selectedProject}
          equipmentLogs={equipmentLogs}
          calenderView={calenderView}
          setCalenderView={setCalenderView}
          checksData={checksData}
          setChecksData={setChecksData}
          checksDataLog={checksDataLog}
          setChecksDataLog={setChecksDataLog}
          startDateInput={startDateInput}
          endDateInput={endDateInput}
          selectedDateInput={selectedDateInput}
          setSelectedDateInput={setSelectedDateInput}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
          intervalListData={intervalListData}
          setIntervalListData={setIntervalListData}
          // isIntervalsLoading={isIntervalsLoading}
          configuredMaintenanceTypes={configuredMaintenanceTypes}
          equipMainIntLoading={equipMaintenanceIntervalLoading}
          setPihMaintenanceType={setPihMaintenanceType}
          pihMaintenanceType={pihMaintenanceType}
          equipmentLogsForm={equipmentLogsForm}
          intervalIdCheck={intervalIdCheck}
          setIntervalIdCheck={setIntervalIdCheck}
          setMaintenanceIdCheck={setMaintenanceIdCheck}
          maintenanceIdCheck={maintenanceIdCheck}
          setClickedTableData={setClickedTableData}
          clickedTableData={clickedTableData}
          historyCurrentPage={historyCurrentPage}
          setHistoryCurrentPage={setHistoryCurrentPage}
          handleCancelTable={handleCancelTable}
          equipLogsDateHeaderSlotRef={equipLogsDateHeaderSlotRef}
        />
            </div>
            <div className="mc-dpr-modal-foot">
              <CrceButton
                label="Close"
                variant="primary"
                size="medium"
                onClick={handleCancelTable}
              />
            </div>
          </div>
        </div>
      )}

      {isDeleteModalVisible && selectedData && (
        <div className="mc-dpr-modal-backdrop" role="presentation">
          <div
            className="mc-dpr-modal mc-dpr-modal--narrow mc-dpr-modal--delete"
            role="dialog"
            aria-labelledby="equip-delete-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mc-dpr-modal-head">
              <h3 id="equip-delete-title" className="mc-dpr-modal-title">
                Delete equipment
              </h3>
              <button
                type="button"
                className="mc-dpr-modal-close"
                aria-label="Close"
                disabled={isEquipDeleteLoading}
                onClick={handleDeleteCancel}
              >
                <X size={20} />
              </button>
            </div>
            <div className="mc-dpr-modal-body">
              <div className="mc-dpr-modal-delete-body">
                <p className="mc-dpr-modal-delete-lead">
                  Deleting this equipment removes all corresponding checks and related information.
                </p>
                <p className="mc-dpr-modal-delete-target">
                  {selectedData?.pihEquipmentType || selectedData?.name || '—'} —{' '}
                  {selectedData?.serialNumber || '—'}
                </p>
                <p className="mc-dpr-modal-delete-warning">This action cannot be undone.</p>
              </div>
            </div>
            <div className="mc-dpr-modal-foot">
              <CrceButton
                label="Cancel"
                variant="tertiary"
                size="medium"
                onClick={handleDeleteCancel}
                disabled={isEquipDeleteLoading}
              />
              <span className="mc-delete-confirm-wrap">
                <CrceButton
                  label={isEquipDeleteLoading ? 'Deleting…' : 'Delete'}
                  variant="primary"
                  size="medium"
                  onClick={handleDeleteOk}
                  disabled={isEquipDeleteLoading}
                />
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({
  equip,
  maintenanceReducer,
  materialReducer,
  adminEquipTypeReducer,
  maintenanceAdminReducer,
  adminEquipSnoReducer,
  checkIntervalReducer,
}) => {
  const isEquipDetailsLoading = get(equip, 'isEquipDetailsLoading', false);
  const isGetEquipDetailsLoading = get(equip, 'isGetEquipDetailsLoading', false);
  const isEquipUpdateLoading = get(equip, 'isEquipUpdateLoading', false);
  const isEquipDeleteLoading = get(equip, 'isEquipDeleteLoading', false);
  const equipDetails = get(equip, 'equipData', []);
  const equipDataCount = get(equip, 'equipDataCount', null);
  const isChecksLoading = get(equip, 'isChecksLoading', false);
  const checksDetails = get(equip, 'checksData', []);
  const checksDetailsLog = get(equip, 'checksLogData', []);
  const maintenanceTypes = get(maintenanceReducer, 'maintenanceTypes', []);
  const materialList = get(materialReducer, 'materialList', []);
  const equipMaintenanceIntervalData = get(equip, 'equipMaintenanceIntervalData', []);
  const equipMaintenanceIntervalLoading = get(equip, 'equipMaintenanceIntervalLoading', false);

  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const adminMaintenanceTypes = get(maintenanceAdminReducer, 'adminMaintenanceTypes', []);
  const adminMaintenanceTypesById = get(maintenanceAdminReducer, 'adminMaintenanceTypesById', []);
  const adminEquipSnoData = get(adminEquipSnoReducer, 'adminEquipSnoData', []);
  const adminEquipSnoLoading = get(adminEquipSnoReducer, 'adminEquipSnoLoading', false);
  const isAdminMaintenanceLoading = get(
    maintenanceAdminReducer,
    'isAdminMaintenanceLoading',
    false
  );

  const categoryData = get(equip, 'categoryData', []);
  const isCategoryLoading = get(equip, 'isCategoryLoading', false);
  const adminDocumentSubCategoryLoad = get(
    adminEquipSnoReducer,
    'adminDocumentSubCategoryLoad',
    false
  );
  const adminDocumentSubTypeSnoData = get(adminEquipSnoReducer, 'adminDocumentSubTypeSnoData', []);

  // const intervalsList = get(checkIntervalReducer, 'intervalsList', []);
  // const isIntervalsLoading = get(checkIntervalReducer, 'isIntervalsLoading', false);
  return {
    isEquipDetailsLoading,
    isGetEquipDetailsLoading,
    equipDetails,
    equipDataCount,
    isEquipUpdateLoading,
    isEquipDeleteLoading,
    isChecksLoading,
    checksDetails,
    maintenanceTypes,
    materialList,
    equipMaintenanceIntervalData,
    equipMaintenanceIntervalLoading,
    adminEquipTypesLoading,

    adminEquipTypes,
    adminMaintenanceTypes,
    adminEquipSnoData,
    adminEquipSnoLoading,
    adminMaintenanceTypesById,
    isAdminMaintenanceLoading,
    checksDetailsLog,

    isCategoryLoading,
    categoryData,
    adminDocumentSubCategoryLoad,
    adminDocumentSubTypeSnoData,
    // intervalsList,
    // isIntervalsLoading,
  };
};

const mapDispatchToProps = {
  onAddEquipData: addEquipDetails,
  onFetchEquipDetails: fetchEquipDetails,
  onUpdateEquipData: updateEquipDetails,
  onDeleteEquipDetails: deleteEquipDetails,
  ongetChecksData: getChecksDetails,
  onGetMaintenanceTypes: fetchMaintenanceTypes,
  onGetMaterialList: fetchMaterialList,
  onGetEquipMaintenanceInterval: fetchEquipMaintenanceIntervalDetails,

  onGetAdminEquipmentTypes: fetchAdminEquipTypes,
  onGetAdminMaintenanceTypes: fetchAdminMaintenanceTypes,
  onGetAdminMaintenanceTypesById: fetchAdminMaintenanceTypesByID,
  onGetEquipSno: fetchAdminEquipSno,
  onGetChecksLogs: getChecksLogDetails,
  onGetCategory: fetchEquipCategory,
  onFetchAdminDocumentSubTypeSno: fetchAdminDocumentSubTypeSno,
};

export default connect(mapStateToProps, mapDispatchToProps)(Equipment);
